import Icon, { IconProps } from './Icon';

import XCloseIcon from '../../../assets/icons/x-close.svg?react';

const XClose: React.FC<Omit<IconProps, 'children'>> = (props) => {
  return (
    <Icon {...props}>
      <XCloseIcon />
    </Icon>
  );
};

export default XClose;
